import React, { SVGProps } from 'react';

export const IconWarning = (props: SVGProps<SVGSVGElement>) => <svg fill="none" viewBox="0 0 32 32" width="1em" height="1em" {...props}><path fill="currentColor" d="M16 28a3 3 0 1 0-.02-6 3 3 0 0 0 .01 6Zm1.98-24h-3.96a.5.5 0 0 0-.5.52l.46 15a.5.5 0 0 0 .5.48h3.04a.5.5 0 0 0 .5-.48l.46-15a.5.5 0 0 0-.5-.52Z"/></svg>;
